import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { asyncValidationService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseCheckIfEmailUniqueMutationProps = {
	onSuccess?: Function;
	onError?: Function;
};

const useCheckIfEmailUniqueMutation = ({
	onSuccess,
	onError,
}: UseCheckIfEmailUniqueMutationProps = {}) => {
	const dispatch = useDispatch();
	return useMutation(
		(email: string) => {
			return asyncValidationService.checkIfEmailUnique(email);
		},
		{
			onSuccess(result) {
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);

				onError?.(error);
			},
		},
	);
};

export default useCheckIfEmailUniqueMutation;
